import AudioPlayer from './AudioPlayer'

export default AudioPlayer
